<template>
  <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter">
    <v-row dense>
      <v-col cols="12" md="9">
        <v-text-field
          v-model="filter"
          :label="$t('filter')"
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn depressed color="#D8D8D8" :block="$vuetify.breakpoint.xsOnly" type="submit">
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <TLoading v-model="loading" />
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ListBillingItemsFiltersComponent',
  data() {
    return {
      path: 'facturacion',
      filter: '',
      loading: false,
    }
  },
  methods: {
    submitFilter() {
      this.setSearch(this.filter)
    },
    ...mapActions({
      setSearch(dispatch, payload) {
        return dispatch('facturacionStore/setSearch', payload)
      },
    })
  },
}
</script>
